import { render, staticRenderFns } from "./KloosterInfo.vue?vue&type=template&id=5f1ee3b4&scoped=true"
import script from "./KloosterInfo.vue?vue&type=script&lang=js"
export * from "./KloosterInfo.vue?vue&type=script&lang=js"
import style1 from "./KloosterInfo.vue?vue&type=style&index=1&id=5f1ee3b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ee3b4",
  null
  
)

export default component.exports